import { gql } from "@apollo/client";

export const PROJECT_ONE_QUERY = gql`
	query Projects($filters: ProjectQueryFilters) {
		projects(filters: $filters) {
			one {
				additionalFeatures
				ageStatus {
					label
					value
				}
				amenitiesStr
				approvalsStr
				area
				bankApprovalsStr
				blocks {
					maxFloors
					numOfUnits
					number
				}
				documentsStr
				id
				images {
					original
					space
					tags
				}
				linkedLocalities
				location {
					gps {
						coordinates
					}
					locality
					roads
				}
				name
				price
				propertyTypes
				rera {
					id
				}
				sellerProjectConfig {
					bedrooms
					configIds
				}
				slug
				specifications
				unitswithconfig {
					bedrooms
					count
					unitIds
				}
				waterSource
			}
		}
	}
`;
export const PROJECT_NEARBY_QUERY = gql`
	query Query($filters: ProjectQueryFilters) {
		projects(filters: $filters) {
			getNearbyProjects {
				id
				name
				cover
				localityName
				location {
					address
					gps {
						coordinates
					}
					city
					pin
				}
			}
		}
	}
`;

export const PROJECT_NEARBY_WITH_SUPS_QUERY = gql`
	query GetNearbyProjectsWithSUPs($filters: ProjectQueryFilters) {
		projects(filters: $filters) {
			getNearbyProjectsWithSUPs {
				_id
				localityName
				projectId
				projectName
				propertyTypes
				center {
					lat
					lng
				}
				zoom
				sups {
					_id
					appCoverImage
					amenities
					bathrooms
					bedrooms
					builtUpAreas
					cover
					facings
					mediaList {
						name
						space
						type
						url
						tags
					}
					parkings
					prices
					sellerProjectId
					totalUnits
					type
					updatedAt
				}
				isExactMatch
			}
		}
	}
`;

//mutations
export const PROJECT_REQUEST_VISIT = gql`
	mutation Project($params: ProjectInputParams) {
		project(params: $params) {
			projectVisitRequest
		}
	}
`;

export const PROJECT_SHORTLIST_MUTATION = gql`
	mutation Project($params: ProjectInputParams) {
		project(params: $params) {
			shortlistProject {
				_id
			}
		}
	}
`;

export const GET_SHORTLISTED_PROJECTS_QUERY = gql`
	query GetShortlistedProjects($filters: ProjectQueryFilters!) {
		projects(filters: $filters) {
			getShortlistedProjects {
				id
				name
				cover
				localityName
				location {
					gps {
						coordinates
					}
					locality
					city
					pin
					address
				}
			}
		}
	}
`;
